import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fff1db1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1fff1db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff1db1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fff1db1')) {
      api.createRecord('1fff1db1', component.options)
    } else {
      api.reload('1fff1db1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1fff1db1&scoped=true&", function () {
      api.rerender('1fff1db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricing/UpgradeStepper/index.vue"
export default component.exports